import { IControl, IField } from 'app/services/api5-service/api.interface';
import { of } from 'rxjs';

import { FieldSettings } from 'common/dynamic-form/wrappers/field-base/model';

import { DateTimeProps } from './model/datetime-props.interface';

import {
  ISPFieldConfig,
  ISPFieldType,
  ISPFieldWrapper,
  ISPFormState,
} from '../../model';

/**
 * Get props for date-time field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 */
export function getDateTimeProps(
  control: IControl,
  field: IField,
): DateTimeProps {
  return {
    originalControl: control,
    originalField: field,
    fieldSettings$: of({
      displayMode: 'input-like',
      tagPlace: 'field',
    } as FieldSettings),
  };
}

/**
 * Get config for date-time field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param _state - dynamic form state
 */
export function getDateTimeConfig(
  control: IControl,
  field: IField,
  _state: ISPFormState,
): ISPFieldConfig<ISPFieldType.DateTime> {
  const props = getDateTimeProps(control, field);

  return {
    type: ISPFieldType.DateTime,
    wrappers: [ISPFieldWrapper.FieldBase],
    props,
  };
}
